import { useCallback } from 'react';
import {
  showResetOrientationAcknowledgement,
  showResetOrientationFailure,
} from '../../Components/Snackbars/resetOrientationAcknowledgementNotification';
import { resetDriveUnitOrientation } from '../../utils/resetDriveUnitOrientation';

export function useResetOrientationAcknowledgement() {
  const resetOrientation = useCallback(() => {
    if (resetDriveUnitOrientation()) {
      showResetOrientationAcknowledgement();
      return;
    }
    showResetOrientationFailure();
  }, []);

  return {
    resetOrientation,
  };
}
